module.exports = require('./helpers/bundle-url').getBundleURL('2uhJ3') + "smallFirePerson.f89a97db.glb" + "?" + Date.now();